import React from "react";
import { useSelector } from "react-redux";
import WizardItem from "./WizardItem";
import WizardPage from "./WizardPage";
import { Stack } from "@atlaskit/primitives";
import { listStyles } from "./utils/wizardstyles";
import { wizardRegistry } from "./tutorials/wizardRegistry";

const WizardsInCategory = () => {
  const currentPage = useSelector((state) => state.wizard.currentPage);
  const currentCategory = useSelector((state) => state.wizard.currentCategory);

  return (
    <>
      {currentPage === 0 && (
        <Stack as="ul" xcss={listStyles}>
          {wizardRegistry.filter(w=>w.category === currentCategory).map((tutorial, i) => (
            <WizardItem key={i} tutorial={tutorial} />
          ))}          
        </Stack>
      )}
      {currentPage > 0 && <WizardPage />}
    </>
  );
};
export default WizardsInCategory;